import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";
import { getCountries } from "../lib/api";
import CountryDrawer from "../components/AddCountry";

const API_BASE = process.env.REACT_APP_API_BASE || "https://api.soksan-dss.com";

const customStyles = `
  .form-grid-container {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 1.5rem !important;
    width: 100% !important;
    margin-bottom: 1.25rem !important;
  }
  .drawer-close {
  position: absolute;
  right: 1rem;
  position: absolute;
  right: 2rem;
  top: 1rem;
  background: none;
  border: none;
  fontSize: 2rem !important;
  cursor: pointer;
  color: #6c757d;
  }
  .form-grid-container > div {
    width: 100% !important;
    box-sizing: border-box !important;
  }
  .form-control, select, textarea {
    width: 100% !important;
    box-sizing: border-box !important;
    border-radius: 8px !important;
    padding: 8px 12px !important;
    border: 1px solid #ced4da !important;
    background: #fff !important;
    font-size: 0.875rem !important;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
  }
  .form-control:focus, select:focus, textarea:focus {
    border-color: #1a73e8 !important;
    box-shadow: 0 0 0 0.2rem rgba(26, 115, 232, 0.25) !important;
    outline: none !important;
  }
  .form-control:disabled, select:disabled {
    background-color: #f8f9fa !important;
    color: #6c757d !important;
    cursor: not-allowed !important;
  }
  .error-message {
    color: #dc3545;
    font-size: 0.75rem;
    margin-top: 0.25rem;
  }
  .success-message {
    color: #28a745;
    font-size: 0.875rem;
    margin-bottom: 1rem;
    text-align: center;
  }
  .image-preview-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1rem;
  }
  .image-preview {
    max-width: 120px;
    max-height: 80px;
    object-fit: contain;
    border-radius: 4px;
    border: 2px solid #e2e8f0;
    padding: 4px;
    background: white;
  }
  .preview-label {
    font-size: 0.75rem;
    color: #6c757d;
    margin-top: 0.5rem;
  }
  .card-body {
    overflow-y: auto !important;
    max-height: calc(100vh - 80px) !important;
    padding: 1.5rem !important;
    overscroll-behavior: contain !important;
  }
  .drawer-header {
    padding: 1.5rem;
    border-bottom: 1px solid #dee2e6;
    position: relative;
  }
  .drawer-title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: #1a73e8;
  }
  .form-label {
    font-size: 0.875rem !important;
    font-weight: 600 !important;
    color: #4a4a4a !important;
    margin-bottom: 0.5rem !important;
    display: block;
  }
  .required-star {
    color: #dc3545;
  }
  .file-input-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
  }
  .file-input-label {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 16px;
    background: #f8f9fa;
    border: 1px dashed #ced4da;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  .file-input-label:hover {
    background: #e9ecef;
    border-color: #1a73e8;
  }
  .file-input-label.disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
  .file-input {
    position: absolute;
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    z-index: -1;
  }
  .file-input-text {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #495057;
    font-size: 0.875rem;
  }
  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
  }
  .current-preview-section {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #e2e8f0;
  }
  .edit-mode-notice {
    background-color: #fff3cd;
    border: 1px solid #ffc107;
    color: #856404;
    padding: 8px 12px;
    border-radius: 4px;
    margin-bottom: 1rem;
    font-size: 0.875rem;
  }
  .auth-error-alert {
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
    color: #721c24;
    padding: 12px;
    border-radius: 4px;
    margin-bottom: 1rem;
  }
  .optional-badge {
    background-color: #6c757d;
    color: white;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 0.75rem;
    margin-left: 8px;
  }
  .country-info {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 0;
  }
  .country-emoji {
    font-size: 1.25rem;
  }
    .excel-upload-container {
        background-color: #fff;
        border: 1px solid #e2e8f0;
        border-radius: 12px;
        padding: 1.25rem;
        margin-top: 0.5rem;
      }
      .excel-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1rem;
      }
      .excel-title {
        font-size: 0.875rem;
        font-weight: 600;
        color: #1e293b;
        margin: 0;
        display: flex;
        align-items: center;
        gap: 0.5rem;
      }
      .download-template-btn {
        font-size: 0.75rem;
        color: #2563eb;
        background: #eff6ff;
        border: 1px solid #dbeafe;
        padding: 6px 12px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        gap: 6px;
        transition: all 0.2s;
        cursor: pointer;
      }
      .download-template-btn:hover {
        background: #dbeafe;
        color: #1d4ed8;
      }
      .upload-area {
        border: 2px dashed #cbd5e1;
        border-radius: 8px;
        padding: 2rem;
        text-align: center;
        cursor: pointer;
        transition: all 0.2s;
        background: #f8fafc;
        position: relative;
      }
      .upload-area:hover {
        border-color: #94a3b8;
        background: #f1f5f9;
      }
      .upload-area.disabled {
        opacity: 0.6;
        cursor: not-allowed;
        pointer-events: none;
      }
      .upload-icon {
        font-size: 2rem;
        color: #64748b;
        margin-bottom: 0.5rem;
      }
      .upload-text {
        font-size: 0.875rem;
        color: #475569;
        margin-bottom: 0.25rem;
        font-weight: 500;
      }
      .upload-hint {
        font-size: 0.75rem;
        color: #94a3b8;
      }
      .preview-card {
        margin-top: 1rem;
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        overflow: hidden;
        background: white;
      }
      .preview-header {
        background: #f8fafc;
        padding: 0.75rem 1rem;
        border-bottom: 1px solid #e2e8f0;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .file-details {
        display: flex;
        align-items: center;
        gap: 0.75rem;
      }
      .file-icon {
        font-size: 1.5rem;
        color: #10b981;
      }
      .file-name {
        font-size: 0.875rem;
        font-weight: 600;
        color: #334155;
        display: block;
      }
      .file-meta {
        font-size: 0.75rem;
        color: #64748b;
      }
      .preview-table-container {
        max-height: 200px;
        overflow-y: auto;
      }
      .preview-table {
        width: 100%;
        font-size: 0.75rem;
        border-collapse: collapse;
      }
      .preview-table th {
        background: #f1f5f9;
        padding: 8px 12px;
        text-align: left;
        font-weight: 600;
        color: #475569;
        position: sticky;
        top: 0;
        border-bottom: 1px solid #e2e8f0;
      }
      .preview-table td {
        padding: 8px 12px;
        border-bottom: 1px solid #f1f5f9;
        color: #334155;
      }
      .remove-btn {
        color: #ef4444;
        background: #fef2f2;
        border: 1px solid #fee2e2;
        padding: 6px;
        border-radius: 6px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;
      }
      .remove-btn:hover {
        background: #fee2e2;
        color: #dc2626;
      }
      .loading-spinner-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 1rem;
        color: #64748b;
        gap: 0.5rem;
      }
      .text-sm { font-size: 0.875rem; }
      .text-xs { font-size: 0.75rem; }
`;
const CountryList = () => {
  const [countries, setCountries] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);

  const [showAddDrawer, setShowAddDrawer] = useState(false);
  const [showEditDrawer, setShowEditDrawer] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);

  // pagination / UI extras
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);

  const fetchCountries = async () => {
    try {
      setLoadingTable(true);
      const token = localStorage.getItem("token") || localStorage.getItem("authToken");
      const data = await getCountries(token);
      if (data.success) {
        setCountries(data.countries || []);
      } else {
        console.error("Failed to fetch countries:", data.message);
      }
      console.log("countrines", countries);
    } catch (err) {
      console.error("Error fetching countries:", err);
    } finally {
      setLoadingTable(false);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  const openEditDrawer = (item) => {
    setSelectedCountry(item);
    setShowEditDrawer(true);
  };

  const handleDrawerSuccess = () => {
    fetchCountries();
  };

  //   // handle delete
  //   const handleDelete = async (id) => {
  //     if (window.confirm("Are you sure you want to delete this country?")) {
  //       try {
  //         const token = localStorage.getItem("token") || localStorage.getItem("authToken");
  //         if (response.success) {
  //           alert("Country deleted successfully");
  //           fetchCountries();
  //         } else {
  //           alert("Failed to delete country: " + response.message);
  //         }
  //       } catch (err) {
  //         console.error("Delete error:", err);
  //         alert("Error deleting country");
  //       }
  //     }
  //   };

  // small helper to render flag image (thumbnail)
  const renderFlagImage = (imgName) => {
    if (!imgName) return null;
    return (
      <img
        src={`${API_BASE}/uploads/flag/${imgName}`}
        alt="flag"
        width="40"
        height="24"
        className="rounded border"
        style={{ objectFit: 'cover' }}
      />
    );
  };

  // pagination slice
  const paged = countries.slice((page - 1) * perPage, page * perPage);
  const pageCount = Math.ceil(countries.length / perPage) || 1;

  return (
    <>
      <style>{customStyles}</style>
      <div className="card h-100 p-0 radius-12">
        <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center flex-wrap gap-3">
            <span className="text-md fw-medium text-secondary-light mb-0">Show</span>
            <select
              className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
              value={perPage}
              onChange={(e) => {
                setPerPage(Number(e.target.value));
                setPage(1);
              }}
            >
              {[5, 10, 20, 50].map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>

            <form
              className="navbar-search"
              onSubmit={(ev) => {
                ev.preventDefault();
                // alert("Implement search endpoint if needed");
              }}
            >
              <input type="text" className="bg-base h-40-px w-auto" name="search" placeholder="Search" />
              <Icon icon="ion:search-outline" className="icon" />
            </form>
          </div>

          <button
            type="button"
            className="btn btn-yellow text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
            onClick={() => setShowAddDrawer(true)}
          >
            <Icon icon="ic:baseline-plus" className="icon text-xl line-height-1" />
            Add Country
          </button>
        </div>

        <div className="card h-100 p-16 radius-12">
          <div className="table-responsive scroll-sm">
            <table className="table bordered-table sm-table mb-0">
              <thead>
                <tr>
                  {/* <th scope="col">S.L</th> */}
                  <th scope="col" className="text-center">Country Name</th>
                  <th scope="col" className="text-center">Country Code</th>
                  <th scope="col" className="text-center">Time Zone</th>
                  <th scope="col" className="text-center">Phone Mask</th>
                  <th scope="col" className="text-center">Flag Image</th>
                  <th scope="col" className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {loadingTable ? (
                  <tr><td colSpan="6" className="text-center">Loading countries...</td></tr>
                ) : paged.length ? (
                  paged.map((item, idx) => (
                    <tr key={item.ID}>
                      {/* <td>{(page - 1) * perPage + idx + 1}</td> */}
                      <td className="text-center">{item.CountryName}</td>
                      <td className="text-center">{item.CountryCode}</td>
                      <td className="text-center">{item.TimeZone || 'N/A'}</td>
                      <td className="text-center">{item.PhoneMask || 'N/A'}</td>
                      <td className="text-center">
                        {renderFlagImage(item.ImageOfFlag)}
                      </td>
                      <td className="text-center">
                        <div className="d-flex align-items-center gap-10 justify-content-center">
                          <button
                            type="button"
                            className="bg-success-100 text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            onClick={() => openEditDrawer(item)}
                          >
                            <Icon icon="lucide:edit" className="menu-icon" />
                          </button>
                          {/* <button
                            type="button"
                            className="remove-item-button bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            // onClick={() => handleDelete(item.ID)}
                          >
                            <Icon icon="fluent:delete-24-regular" className="menu-icon" />
                          </button> */}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr><td colSpan="6" className="text-center">No countries found</td></tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
            <span>
              Showing {(page - 1) * perPage + 1} to {Math.min(page * perPage, countries.length)} of {countries.length} entries
            </span>
            <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
              <li className="page-item">
                <Link
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                  to="#"
                  onClick={() => setPage((p) => Math.max(1, p - 1))}
                >
                  <Icon icon="ep:d-arrow-left" />
                </Link>
              </li>
              {Array.from({ length: pageCount }).map((_, i) => (
                <li key={i} className="page-item">
                  <Link
                    className={`page-link text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${page === i + 1 ? "bg-primary-600 text-white" : "bg-neutral-200"}`}
                    to="#"
                    onClick={() => setPage(i + 1)}
                  >
                    {i + 1}
                  </Link>
                </li>
              ))}
              <li className="page-item">
                <Link
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                  to="#"
                  onClick={() => setPage((p) => Math.min(pageCount, p + 1))}
                >
                  <Icon icon="ep:d-arrow-right" />
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Add Country Drawer */}
      <CountryDrawer
        isOpen={showAddDrawer}
        onClose={() => setShowAddDrawer(false)}
        onSuccess={handleDrawerSuccess}
      />

      {/* Edit Country Drawer */}
      <CountryDrawer
        isOpen={showEditDrawer}
        onClose={() => {
          setShowEditDrawer(false);
          setSelectedCountry(null);
        }}
        countryToEdit={selectedCountry}
        onSuccess={handleDrawerSuccess}
      />
    </>
  );
};

export default CountryList;